<template>
    <div class="h-fit white-rounded-box w-full m-5">
        <!-- TODO: conditionally make bottom border rounded if there are no comments -->
        <div
            class="flex flex-col justify-between post-content-wrapper h-fit p-5 text-center"
        >
            <div class="flex mb-2">
                <component
                    class="linebreak text-xl"
                    :is="renderedContent"
                ></component>
            </div>
            <div class="flex mt-2" v-if="post.documents">
                <ul v-for="document in post.documents" :key="document.id">
                    <FilePreview
                        v-if="document.thumbnail_uri"
                        :image="document.thumbnail_uri"
                    />
                    <a
                        :href="document.pivot.full_uri"
                        target="_blank"
                        class="text-salesium-blue text-lg"
                        >{{ document.name }}</a
                    >
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import FilePreview from "../../Utils/FilePreview.vue";
export default {
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            observer: null,
            showingDefaultAvatar: true,
        };
    },
    methods: {},
    computed: {
        renderedContent() {
            const userRegex = RegExp(
                /\B@{([a-z0-9_-]+)}{([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})}/gi
            );

            let contentWithMentions = this.post.content.replaceAll(
                userRegex,
                (match, username, id) => {
                    const user = this.post.mentions.find(
                        (mention) => mention.id === id
                    );
                    if (user) {
                        if (user.type == "pro") {
                            return `<a href="${user.storefront_url}" class="no-underline">@${user.display_name}</a>`;
                        } else {
                            return `<a class="no-underline">@${user.display_name}</a>`;
                        }
                    } else {
                        // TODO: implement fallback for non-existent user
                        return `@${username}`;
                    }
                }
            );

            const tagRegex = RegExp(/\B#([a-z0-9_]+)/gi);

            let contentWithTags = contentWithMentions.replaceAll(
                tagRegex,
                (match) => {
                    return `<a @click="()=>{this.$emit('tagClicked', '${match}')}" class="no-underline inline-flex items-center px-3 py-2 rounded-full font-medium leading-4 bg-gray-200 text-gray-800">${match}</a>`;
                }
            );

            return {
                template: "<div>" + contentWithTags + "</div>",
            };
        },
    },
    components: {
        FilePreview,
    },
};
</script>

<style scoped>
.post-content-wrapper {
    min-height: 184px;
}
.badgeBlue {
    border-width: 4px;
}
.badgeGreen {
    border-width: 4px;
}
.linebreak {
    white-space: pre-wrap;
}
</style>
